export enum contactsActionTypes {
	SET_ADD_CONTACT_LOADING = 'SET_ADD_CONTACT_LOADING',
	SET_CONTACT_DETAILS_LOADING = 'SET_CONTACT_DETAILS_LOADING',
	FETCH_CONTACT_DETAILS_DATA = 'FETCH_CONTACT_DETAILS_DATA',
}
